import React from 'react';

const header = () => {
    return (
        <div className="header-wrapper">
            <div className="row">
                <div className="main-info">
                    <div className="header-text">
                        <h1>I'm Hannah McDonald.</h1>
                        <h3>I'm an Atlanta based <b> Full-Stack Software Engineer.</b></h3>
                    </div>
                </div>
            </div>
         </div>
    )
}

export default header